import { useEffect, useState } from "react"
import { useIntl } from "react-intl"

import { fetchBookingHistory } from "api"
import { useAppDispatch } from "lib/hooks"

import History, { HistoryEvent } from "../shared/History"

export interface BookingHistoryEvent extends HistoryEvent {
  bookingId: string
}

interface BookingHistoryProps {
  bookingId: string
}

const BookingHistory = ({ bookingId }: BookingHistoryProps) => {
  const dispatch = useAppDispatch()
  const intl = useIntl()
  const [bookingHistory, setBookingHistory] = useState<BookingHistoryEvent[]>()

  useEffect(() => {
    bookingId && dispatch(fetchBookingHistory(bookingId)).then(setBookingHistory)
  }, [dispatch, bookingId])

  const eventTypeMap: Record<string, string> = {
    booking_cancelled_by_patient: intl.formatMessage({ id: "booking.history.event.cancelled" }),
    booking_created_by_patient: intl.formatMessage({ id: "booking.history.event.created" }),
    booking_rescheduled_by_patient: intl.formatMessage({ id: "booking.history.event.rescheduled" }),
    booking_created_by_staff: intl.formatMessage({ id: "booking.history.event.created" }),
    booking_cancelled_by_staff: intl.formatMessage({ id: "booking.history.event.cancelled" }),
    booking_rescheduled_by_staff: intl.formatMessage({ id: "booking.history.event.rescheduled" }),
    booking_reassigned_by_staff: intl.formatMessage({ id: "booking.history.event.reassigned" })
  }

  if (!bookingHistory) return null

  return <History history={bookingHistory} eventTypeMap={eventTypeMap} />
}

export default BookingHistory
